



































































































































































































































































































import { Component, Emit, Model, Prop, Ref, Vue, Watch, PropSync } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import { Decision } from '@/api/model/Decision';
import Decisions from '@/store/modules/Decisions';
import Apps from '@/store/modules/Apps'
import { Urls } from '@/Urls';
import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';
import DecisionShareDialog from '@/components/decisions/DecisionManageUsersDialog.vue';
import ModelScoringKeyButtonTrigger from '@/components/scoring-key/ModelScoringKeyButtonTrigger.vue';
import UserAvatar from '@/components/common/UserAvatar.vue';
import { NotificationEventBus } from '@/EventBus';
import TemplateLaunchDialog from '@/components/apps/TemplateLaunchDialog.vue';
import LaunchAppLoadingDialog from '@/components/apps/LaunchAppLoadingDialog.vue';

const decisionsModule = getModule(Decisions);
const appModule = getModule(Apps);

@Component({
    components: {
        ConfirmationDialog,
        DecisionShareDialog,
        ModelScoringKeyButtonTrigger,
        UserAvatar,
        TemplateLaunchDialog,
        LaunchAppLoadingDialog
    },
})
export default class DecisionSelector extends Vue {
    @Prop({ default: false, type: Boolean })
    loading!: boolean;

    @PropSync('createDecisionDialog', { type: Boolean, default: false })
    createDecisionDialogSync!: boolean;

    @PropSync('editDecisionDialog', { type: Boolean, default: false })
    editDecisionDialogSync!: boolean;

    @Prop({ default: '', type: String })
    scoreTabs!: string;

    

    private decisionSelectorMenuShow: boolean = false;

    private readonly URLS = Urls;
    private loadingDialog = false;
    get selectedDecision() {
        return decisionsModule.selectedDecision;
    }

    get decisionTemplateDict(){
        return appModule.decisionTemplatesDict;
    }
    set selectedDecision(decision: Decision | null) {
        if (decision) {
            appModule.setCurrentAppUrl('');
            decisionsModule.selectDecision(decision.decisionId).then(res=>{
                this.$emit('selectedDecision', decision);
            });
        }
    }

    get decisions() {
        return Object.values(decisionsModule.decisions).sort((a: any, b: any) => {
            if (a.name === null || a.name === undefined) a.name = '';
            if (b.name === null || b.name === undefined) b.name = '';
            return a.name.localeCompare(b.name);
        });
    }

    get decisionsByGroup() {
        let mDashNumber = 7;
        let dDashNumber = 13;
        if (this.decisions && this.decisions.length > 0) {

            let combined = [];
            let decisionTemplate = this.decisions.filter(x => this.decisionTemplateDict[x.decisionId]);
            let decisions = this.decisions.filter(x => !this.decisionTemplateDict[x.decisionId]);
            let templateDivide = {decisionId: 'templateDivider', name: `${'-'.repeat(mDashNumber)} Marketplace Items ${'-'.repeat(mDashNumber)}`, disabled: true};
            combined.push(templateDivide);
            if (decisionTemplate.length > 0 ){
                combined = combined.concat(decisionTemplate);
            } else {
                combined.push({decisionId: 'noMarketplace', name: 'No Marketplace Item', disabled: true})
            }
            let decisionDivide = {decisionId: 'decisionDivider', name: `${'-'.repeat(dDashNumber)} Decisions ${'-'.repeat(dDashNumber+1)}`, disabled: true};
            combined.push(decisionDivide);
            if ( decisions.length > 0){
                combined = combined.concat(decisions);
            } else {
                combined.push({decisionId: 'noDecision', name: 'No Decision Found', disabled: true});
            }
            return combined;
        } else {
            return [];
        }
    }

    private async deleteDecision(decisionId: string) {
        await decisionsModule.deleteDecision(decisionId);
        this.$router.push({ name: 'DecisionManager' });
    }

    private getBadgeColor(decision:any){
        if( decision.decisionTemplateId){
            return "red";
        }else if ( this.decisionTemplateDict[decision.decisionId]){
            return "primary";
        } else {
            return "grey";
        }
    }

    private async pasteDecision(payload) {
        try {
            this.loadingDialog = true;
            await decisionsModule.copyIntoNewDecision({decision: this.selectedDecision, params: payload})
        } catch (err) {
            console.log(err)
        }
        this.loadingDialog = false;
    }
}
